import clsx from "clsx"
import React from "react"

import { BaseButton, BaseButtonProps } from "./BaseButton"

export type AccentButtonProps = {} & Omit<BaseButtonProps, "className">

export const AccentButton: React.FC<AccentButtonProps> = (props) => <BaseButton {...props} className={clsx("accent")} />
